module.exports = __webpack_public_path__ + "img/拍立得.1d2630c0.png";